export default class TagsModel {
  constructor (data) {
    this.completedCodes = data.completedCodes
    this.totalCodes = data.totalCodes
    this.campaignId = data.campaignId
    this.id = data.id
    this.key = data.id
    this.campaignName = data.campaignName
    this.value = data.value === 'Total Codes' ? this.campaignName : data.value
    this.title = this.value
    this.name = data.name
    this.count = 4
  }
}



// WEBPACK FOOTER //
// ./src/api/campaigns/TagsModel.js